<template>
  <div class="c-profiles-popup c-profiles-popup--edit">
    <div class="c-profiles-popup__headline">
      <h1
        v-dompurify-html="$t('subscriber.profile.edit')"
        class="o-typography__headline4"
      ></h1>
    </div>

    <form @submit.prevent="save">
      <div class="c-profiles-popup__form-container">
        <ui-profile-edit-form
          :profile="profileData"
          :is-name-valid="isNameValid"
          :errors="errors"
        ></ui-profile-edit-form>
      </div>

      <div class="c-profiles-popup__buttons-container">
        <div
          class="o-button o-button--text c-profiles-popup__button"
          @click="back"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.cancel') }}
          </span>
        </div>
        <button
          type="submit"
          class="o-button o-button--text c-profiles-popup__button"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.save') }}
          </span>
        </button>
        <div
          v-if="selectedProfile.id !== subscriber.activeProfileId"
          class="o-button o-button--text c-profiles-popup__button"
          @click="showModal"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.remove') }}
          </span>
        </div>
      </div>
    </form>
    <span
      class="c-profiles-popup__icon-close o-icon o-icon--close o-typography--action"
      @click="back"
    ></span>
  </div>
</template>
<script>
  import { ModalType } from '@/shared/enums';
  import { errorMapper } from '@/shared/utils';
  import ProfileAction from './profile-action';
  import UiProfileEditForm from './form.vue';

  export default {
    components: {
      UiProfileEditForm,
    },
    props: {
      selectedProfile: Object,
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
        profilesService: this.$services.resolve('profiles'),
        avatarEdit: false,
        profileData: {},
        isNameValid: true,
        errors: {},
      };
    },
    created() {
      this.profileData = {
        name: this.selectedProfile.name,
        avatar: this.selectedProfile.avatar,
        color: this.selectedProfile.color,
        kids: this.selectedProfile.kids,
      };
    },
    methods: {
      save() {
        this.errors = {};

        if (this.profileData.name.length === 0) {
          this.isNameValid = false;
          return;
        }

        this.profilesService.update(this.selectedProfile.id, this.profileData, { reset: true }).then(() => {
          this.back();
          this.selectedProfile.avatar = this.profileData.avatar;

          if (this.selectedProfile.id === this.subscriber.activeProfileId) {
            this.subscriber.activeProfileId = this.selectedProfile.id;

            if (this.profileData.kids) {
              this.close();
            }
          }
        }).catch((e) => {
          return errorMapper(this, e).then((errors) => {
            this.errors = errors;
          });
        });
      },
      showModal() {
        this.$modal.create({
          id: ModalType.ACCOUNT,
          component: () => import('./remove.vue'),
        }).then((modal) => {
          modal.$on('submit', this.submittedRemove);
        });
      },
      submittedRemove() {
        this.profilesService.destroy(this.selectedProfile.id)
          .then(this.back)
          .catch((e) => {
            return errorMapper(this, e).then((errors) => {
              this.errors = errors;
            });
          });
      },
      back() {
        this.$emit('action', ProfileAction.SHOW_LIST);
      },
      close() {
        this.$emit('action', ProfileAction.CLOSE);
      },
    },
  };
</script>
